import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function FormsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <rect
        x="38"
        y="30"
        width="84"
        height="106"
        rx="12"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="62" y="22" width="36" height="16" rx="8" fill={c.p600} />
      <rect
        x="52"
        y="50"
        width="56"
        height="14"
        rx="7"
        fill={c.p50}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect
        x="52"
        y="72"
        width="56"
        height="14"
        rx="7"
        fill={c.p50}
        stroke={c.p500}
        strokeWidth="2"
      />
      <rect
        x="52"
        y="94"
        width="56"
        height="14"
        rx="7"
        fill={c.p50}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="64" y="114" width="32" height="14" rx="7" fill={c.s500} />
      <path d="M73 121l5 5 9-10" stroke={c.n0} strokeWidth="3" />
    </Frame>
  );
}
